import { ICurrency } from "@protoplan/types";
import { axiosInstance } from "./axiosInstance";


export async function getCurrencies()
{
  return axiosInstance.post("/currencies/currencies")
    .then(resJson => resJson.data as ICurrency[])
    .catch(error => console.log("Error retrieving currencies", error));
}

export async function getExchangeRate(fromCurrencyCode: string, toCurrencyCode: string)
{
  return axiosInstance.post("/currencies/exchangeRate", { fromCurrencyCode, toCurrencyCode })
    .then(resJson => (resJson.data as { exchangeRate?: number }).exchangeRate || 1)
    .catch(error =>
    {
      console.log("Error retrieving exchange rate", error);
      return 1;
    });
}

export async function postExchangeRate(fromCurrencyCode: string, toCurrencyCode: string, exchangeRate: number)
{
  return axiosInstance.post("/currencies/updateExchangeRate", { fromCurrencyCode, toCurrencyCode, exchangeRate })
    .catch(error => console.log("Error retrieving exchange rate", error));
}

